(() => {
  if (customElements.get('sk-coupon-note')) return;
  customElements.define('sk-coupon-note', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.panel = this.querySelector('.sk-coupon-note__panel');
      if (!this.details || !this.trigger || !this.panel) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details.setAttribute('data-enhanced', '');
      this.pinned = false;
      this.hoverOpened = false;
      this.details.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || this.details.open) return;
        this.hoverOpened = true;
        this.show();
      }, options);
      this.details.addEventListener('pointerleave', () => {
        if (!this.pinned && !this.contains(document.activeElement)) this.close();
      }, options);
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.hoverOpened || !this.details.open) {
          this.pinned = true;
          this.hoverOpened = false;
          this.show();
        } else {
          this.close();
        }
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.details.open) return;
        const hadFocus = this.contains(document.activeElement);
        this.close();
        if (hadFocus) this.trigger.focus();
      }, options);
      window.addEventListener('resize', () => this.close(), options);
      window.addEventListener('scroll', (event) => {
        if (!this.panel.contains(event.target)) this.close();
      }, { ...options, capture: true, passive: true });
    }
    show() {
      this.details.open = true;
      const anchor = this.trigger.getBoundingClientRect();
      const box = this.panel.getBoundingClientRect();
      const left = Math.max(12, Math.min(anchor.left, window.innerWidth - box.width - 12));
      const top = anchor.bottom + box.height <= window.innerHeight - 12
        ? anchor.bottom : Math.max(12, anchor.top - box.height);
      this.panel.style.left = `${left}px`;
      this.panel.style.top = `${top}px`;
    }
    close() {
      this.details.open = false;
      this.pinned = false;
      this.hoverOpened = false;
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
})();
